import { defaultPageSize } from 'consts'
import { getSettingsValue } from 'shared/components/App/Auth'

const getPageSize = (page: string): number => {
  return getSettingsValue(page) ?? defaultPageSize
}

export default getPageSize
